import { Injectable, signal } from '@angular/core';

/**
 * Tiny shared flag that the accountGateInterceptor reads to hard-halt all
 * Vigilant API traffic once the initial `GET api/users/self` is forbidden (403).
 *
 * Kept separate from UserSelfService (which owns the self resource and the retry
 * state) so the interceptor can read it without injecting a service that itself
 * issues HTTP — that would be a construction-time DI cycle.
 */
@Injectable({ providedIn: 'root' })
export class AccountGateService {
  /** True once self has 403'd — every API call except the self probe is blocked. */
  readonly blocked = signal(false);
}
